/**
 * @generated SignedSource<<9612834897878e6e0e746b411ed2976f>>
 * @relayHash 591e5a64cd39c5711484ae5bf44555f3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 31597ee9b844f996baf7db704f197520752c0c643e5453dfab9e40d9fb175bd6

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldOptionIdsFilterOperation = "ALLOW" | "EXCLUDE" | "%future added value";
export type JiraFieldOptionIdsFilterInput = {
  operation: JiraFieldOptionIdsFilterOperation;
  optionIds: ReadonlyArray<string>;
};
export type issueType_SearchRefetchQuery$variables = {
  after?: string | null | undefined;
  filterById?: JiraFieldOptionIdsFilterInput | null | undefined;
  first?: number | null | undefined;
  id: string;
  searchBy?: string | null | undefined;
};
export type issueType_SearchRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef">;
};
export type issueType_SearchRefetchQuery = {
  response: issueType_SearchRefetchQuery$data;
  variables: issueType_SearchRefetchQuery$variables;
};
({
  "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": isInlineManageWorkTypesConfigNinIccEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider: {
    readonly get: () => boolean;
  };
});

import isInlineManageWorkTypesConfigNinIccEnabled_provider from '@atlassian/jira-relay-provider/src/jira-nin-inline-manage-work-type-config.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterById"
},
v2 = {
  "defaultValue": 1000,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v4 = {
  "defaultValue": "",
  "kind": "LocalArgument",
  "name": "searchBy"
},
v5 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v6 = {
  "kind": "Variable",
  "name": "filterById",
  "variableName": "filterById"
},
v7 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v8 = {
  "kind": "Variable",
  "name": "id",
  "variableName": "id"
},
v9 = {
  "kind": "Variable",
  "name": "searchBy",
  "variableName": "searchBy"
},
v10 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v11 = [
  (v5/*: any*/),
  (v6/*: any*/),
  (v7/*: any*/),
  (v9/*: any*/)
],
v12 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "issueType_SearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "issueType_issueFieldIssueTypeEditviewFull_IssueTypeEditViewWithFieldOptionsFragment_queryFragmentRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "issueType_SearchRefetchQuery",
    "selections": [
      {
        "args": [
          (v8/*: any*/)
        ],
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v10/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "args": (v11/*: any*/),
                "concreteType": "JiraIssueTypeConnection",
                "kind": "LinkedField",
                "name": "issueTypes",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraIssueTypeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      },
                      {
                        "concreteType": "JiraIssueType",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v10/*: any*/),
                          (v12/*: any*/),
                          {
                            "alias": "value",
                            "kind": "ScalarField",
                            "name": "id"
                          },
                          {
                            "alias": "label",
                            "kind": "ScalarField",
                            "name": "name"
                          },
                          {
                            "concreteType": "JiraAvatar",
                            "kind": "LinkedField",
                            "name": "avatar",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "small"
                              }
                            ]
                          },
                          {
                            "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider",
                            "kind": "Condition",
                            "passingValue": true,
                            "selections": [
                              {
                                "kind": "ScalarField",
                                "name": "issueTypeId"
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v11/*: any*/),
                "filters": [
                  "searchBy",
                  "filterById"
                ],
                "handle": "connection",
                "key": "issueType_issueFieldIssueTypeEditviewFull_issueTypes",
                "kind": "LinkedHandle",
                "name": "issueTypes"
              }
            ],
            "type": "JiraIssueTypeField"
          },
          (v12/*: any*/)
        ]
      }
    ]
  },
  "params": {
    "id": "31597ee9b844f996baf7db704f197520752c0c643e5453dfab9e40d9fb175bd6",
    "metadata": {},
    "name": "issueType_SearchRefetchQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "__relay_internal__pv__atlassianjirarelayprovidersrcjiranininlinemanageworktypeconfigrelayprovider": isInlineManageWorkTypesConfigNinIccEnabled_provider
    }
  }
};
})();

(node as any).hash = "54c04d4f507b644a10ef1cc8b3c0fc09";

export default node;
